export const DEFAULT_ATMOSPHERE_PROFILE_BATCH_CONCURRENCY = 5;
export const MAX_ATMOSPHERE_PROFILE_BATCH_CONCURRENCY = 10;
